module.exports = __webpack_public_path__ + "media/images/android-app-download-3ec8963af4b08fd6737d5be2806d9d87.png";